export default {
	'.*SERVICE_CENTER.*': 'ServiceCenter Landing Page',
	'.*MAINTENANCE_SCHEDULE.*': 'MaintenanceSchedule Landing Page',
	'.*OIL_CHANGES.*': 'OilChange Landing Page',
	'.*EXPRESS_SERVICE.*': 'ExpressService Landing Page',
	'.*PREVENTATIVE_MAINTENANCE.*': 'PreventativeMaintenance Landing Page',
	'.*SERVICE_SPECIALS.*': 'ServiceSpecials Landing Page',
	'.*MEET_OUR_TEAM.*': 'MeetOurTeam Landing Page',
	'.*PARTS_CENTER.*': 'PartsCenter Landing Page',
	'.*KIA_PARTS.*': 'GenuineKiaParts Landing Page',
	'.*TIRE_CENTER.*': 'TireCenter Landing Page',
	'.*PARTS_SPECIALS.*': 'PartsSpecials Landing Page',
	'.*THE_NEW_2021_KIA_SORENTO.*': 'LandingPage_MY21Sorento',
	'.*SERVICE_CENTER_ORDER_PARTS.*': 'OrderParts Landing Page'
};
